import React from 'react';
import { Lightbulb, Code, Rocket, CheckCircle } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      icon: Lightbulb,
      title: 'Ideate',
      description: 'Share your concept. We refine your vision and turn it into a clear execution plan.',
    },
    {
      number: '2',
      icon: Code,
      title: 'Build',
      description: 'We develop your MVP quickly using modern frameworks, rapid prototyping, and AI-assisted development.',
    },
    {
      number: '3',
      icon: Rocket,
      title: 'Launch',
      description: 'Deploy to production with scalable architecture and clean UX/UI ready for users.',
    }
  ];

  return (
    <section id="how-it-works" className="py-24 px-6 relative bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-white/60 font-semibold text-sm uppercase tracking-wide">Process</span>
          <h2 className="text-4xl md:text-5xl font-extrabold mt-4 mb-4 text-white">
            We Simplify Workflows to Get
            <span className="block">Optimal Results</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">From idea to launch in three simple steps</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card
                key={index}
                className="bg-white/5 border-white/10 hover:border-white/30 transition-all duration-300 hover:transform hover:-translate-y-2 group backdrop-blur-sm"
              >
                <CardContent className="p-8">
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                    <span className="text-6xl font-extrabold text-white/10 group-hover:text-white/20 transition-colors duration-300">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-white">{step.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{step.description}</p>
                  <div className="mt-6 flex items-center text-white/80 font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    <CheckCircle className="w-5 h-5 mr-2" />
                    <span>Ready to go</span>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;